import React, { useState } from "react";
import Login from "../../assets/icons/login.png";
import Logo from "../../assets/images/pnmb-logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import "./HomePage.css";
import logo from "../../assets/images/LAWNET LOGO.jpg";
import Cookies from "js-cookie";
import FeedbackDialog from "../../components/FeedbackDialog";

export default function Header({ handleLogin, handleDashboard }) {
  const navigate = useNavigate();
  const location = useLocation();
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const userObject = JSON.parse(cookie);
  const [openDialog, setOpenDialog] = useState(false);

  const goToPrivacyPolicy = () => {
    navigate("/privacy-policy");
  };

  const scrollToSection = (id) => {
    if (location.pathname === "/privacy-policy") {
      navigate("/", { replace: true });
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          const yOffset = 0;
          const y =
            section.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 0); // Ensure the navigation has taken effect before scrolling
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  const handleHome = () => {
    navigate("/");
    scrollToSection("home");
  };

  const handleSocial = (url) => {
    if (!url) {
      console.error("No URL provided");
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="homepage-header">
      <div
        className="homepage-logo"
        onClick={handleHome}
        style={{ cursor: "pointer" }}
      >
        <img src={Logo} width={"25%"} alt="" />
        <img
          src={logo}
          style={{ height: "32px", width: "auto" }}
          className="drawer-logo"
          alt=""
        />
      </div>
      <div className="homepage-tabs">
        <p
          id="headerAboutUs"
          style={{ cursor: "pointer" }}
          onClick={() => scrollToSection("about-us")}
        >
          ABOUT US
        </p>
        <p
          style={{ cursor: "pointer" }}
          onClick={() => scrollToSection("features")}
        >
          FEATURES
        </p>
        <p
          style={{ cursor: "pointer" }}
          onClick={() => scrollToSection("subscription")}
        >
          SUBSCRIPTION
        </p>
        <p style={{ cursor: "pointer" }} onClick={goToPrivacyPolicy}>
          PRIVACY POLICY
        </p>
        <p style={{ cursor: "pointer" }} onClick={() => setOpenDialog(true)}>FEEDBACK</p>
        <div className="homepage-divider"></div>
        <div className="homepage-socialmedia">
          <div
            className="icon-container"
            style={{ cursor: "pointer" }}
            onClick={() => handleSocial("https://www.facebook.com/PNMBLawnet")}
          >
            <FaFacebookF />
          </div>
          <div
            className="icon-container"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleSocial("https://www.instagram.com/pnmblawnet/")
            }
          >
            <FaInstagram />
          </div>
          <div
            className="icon-container"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleSocial("https://www.youtube.com/@pnmb_official/")
            }
          >
            <FaYoutube />
          </div>
        </div>
        <div className="homepage-divider"></div>
        {userObject ? (
          <div className="homepage-login" onClick={handleDashboard}>
            <p>Welcome, {userObject.user.userName}</p>
            <img src={Login} alt="" />
          </div>
        ) : (
          <div className="homepage-login" onClick={handleLogin}>
            <p>LOGIN</p>
            <img src={Login} alt="" />
          </div>
        )}
      </div>
      <FeedbackDialog openDialog={openDialog} setOpenDialog={setOpenDialog} showEmail={true} />
    </div>
  );
}
